<template>
  <div id="object-dialog">
    <el-dialog
      title="创建Bucket"
      :visible.sync="dialog"
      width="35%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :rules="rules" ref="form" :model="ruleForm" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="分组" prop="ownerId">
          <el-select style="width: 60%" v-model="ruleForm.ownerId">
            <el-option
              v-for="item in userGroup"
              :label="item.groupName"
              :value="item.groupId"
              :key="item.groupId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权限" prop="protectType">
          <el-select style="width: 60%" v-model="ruleForm.protectType">
            <el-option label="private" value="private"></el-option>
            <el-option label="public" value="public"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')" :disabled="loading"
          >取 消</el-button
        >
        <el-button :loading="loading" type="primary" @click="submitForm('form')"
          >立即创建</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean
    }
  },
  name: "object-dialog",
  data() {
    return {
      loading: false,
      ruleForm: {
        ownerId: "",
        name: "",
        protectType: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入bucket名称",
            trigger: "blur"
          }
        ],
        ownerId: [
          {
            required: true,
            type: "number",
            message: "请选择分组",
            trigger: "select"
          }
        ],
        protectType: [
          {
            required: true,
            message: "请选择分组",
            trigger: "select"
          }
        ]
      }
    };
  },
  computed: {
    userGroup() {
      return this.$store.state.userGroup;
    }
  },
  watch: {
    dialog: {
      immediate: true,
      handler(v) {
        if (v) {
          this.ruleForm.ownerId = this.userGroup[0].groupId;
        }
      }
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("update:dialog", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.newBucket();
        }
      });
    },
    newBucket() {
      this.loading = true;
      this.$http
        .post(
          "/gavial/v1/mos/bucket?bucket=" +
            this.ruleForm.name +
            "&groupId=" +
            this.ruleForm.ownerId +
            "&protectType=" +
            this.ruleForm.protectType
        )
        .then(() => {
          this.$notify({
            type: "success",
            title: "成功",
            message: `${this.ruleForm.name} 创建成功`,
            duration: 2000
          });
          this.resetForm("form");
          this.$emit("refush");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
